import { HotelHeaderInfo } from './../../../core/store/general/state';
import { FacilitiesTabInfo, Checkin, PricingPolicy } from './../../results/hotel-single/hotel-single.component';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-booking-info',
    templateUrl: 'booking-info.component.html',
    styleUrls: ['booking-info.component.css', 'booking-info.component.scss']
})

export class BookingInfoComponent implements OnInit {

    @Input() type: string;
    @Input() facilities: FacilitiesTabInfo;
    @Input() languages: Array<string>;
    @Input() checkinInfo: Checkin;
    @Input() pricingPolicy: PricingPolicy;
    @Input() bookingRequest;
    @Input() hotelInfo: HotelHeaderInfo;
    @Input() rooms;
    @Input() roomsToShow;
    @Input() guestDeatailsDisabled;
    @Input() mapInformation;
    @Input() offerNote;
    @Input() finalWishes: Map<String, Boolean>;
    @Input() cards;
    @Output() bookNowEv: EventEmitter<any> = new EventEmitter();

    estimatedTimes = new Array<string>();
    estimatedEndTimes = new Array<string>();
    public showdetails = false;

    cardsVisible: Boolean = false;

    countries = ['-', 'Afghanistan', 'Åland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla',
        'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas',
        'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan',
        'Bolivia, Plurinational State of', 'State of Bonaire Sint Eustatius and Saba', 'Bosnia and Herzegovina',
        'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina',
        'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic Central', 'Chad',
        'Chile', 'China', 'Christmas', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo,', 'Cook', 'Costa', 'Côte',
        'Croatia', 'Cuba', 'Curaçao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica Dominica', 'Dominican Republic',
        'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland', 'Faroe Islands',
        'Fiji', 'Finland', 'France', 'French', 'French', 'French', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar',
        'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana',
        'Haiti', 'Heard Island and McDonald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland',
        'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan',
        'Kazakhstan', 'Kenya', 'Kiribati', 'Korea,', 'Korea,', 'Kuwait', 'Kyrgyzstan', 'Lao', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia',
        'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Macedonia,', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives',
        'Mali', 'Malta', 'Marshall', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia', 'Moldova', 'Monaco',
        'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands',
        'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern', 'Norway', 'Oman',
        'Pakistan', 'Palau', 'Palestinian', 'Panama', 'Papua', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal',
        'Puerto Rico', 'Qatar', 'Réunion', 'Romania', 'Russian Federation', 'Rwanda', 'Saint Barthélemy', 'Saint Helena,',
        'Saint Kitts', 'Saint Lucia', 'Saint Martin', 'Saint Pierre', 'Saint Vincent', 'Samoa', 'San Marino', 'Sao Tome',
        'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten(Dutch part)',
        'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia', 'South Sudan', 'Spain',
        'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian',
        'Taiwan, Province of China', 'Tajikistan', 'Tanzania,', 'Thailand', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga',
        'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda',
        'Ukraine', 'United ArabEmirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands',
        'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela,', 'Viet', 'Virgin Islands, British', 'Virgin Islands, U.S. ',
        'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'];

    selectedValue = this.countries[this.countries.indexOf('Greece')];
    @Input() guestDetails;

    constructor() { }

    ngOnInit() {
        for (let i = 0; i < 24; i++) {
            let time = '';
            if (i < 10) {
                time = '0' + i + ':00';
            } else {
                time = i + ':00';
            }
            this.estimatedTimes.push(time);
            this.estimatedEndTimes.push(time);
        }
        this.estimatedEndTimes.push('24:00');
    }

    isVoucher() {
        if (this.type === 'voucher') { return true; }
        return false;
    }

    getPeople() {
        const size = this.bookingRequest.noOfAdults + this.bookingRequest.noOfChildren;
        return new Array(size).fill(0);
    }

    getNightsDifference(from, to) {
        const date1 = new Date(from);
        const date2 = new Date(to);
        const timeDiff = Math.abs(date2.getTime() - date1.getTime());
        return Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    getDate(date) {
        return this.formatDate(date);
    }

    getNightsSafari(from, to) {
        const fromDate = from.replace(/-/g, '/');
        const toDate = to.replace(/-/g, '/');
        const date1 = new Date(fromDate);
        const date2 = new Date(toDate);
        const timeDiff = Math.abs(date2.getTime() - date1.getTime());
        return Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    formatDate(date) {
        const monthNames = [
            'January', 'February', 'March',
            'April', 'May', 'June', 'July',
            'August', 'September', 'October',
            'November', 'December'
        ];
        const dayNames = [
            'Sunday', 'Monday', 'Tuesday',
            'Wednesday', 'Thursday', 'Friday', 'Saturday'];


        const dateFinal = date.replace(/-/g, '/');
        const dateFinal2 = new Date(dateFinal);

        const day = dateFinal2.getDate();
        const weekDay = dateFinal2.getDay();
        const monthIndex = dateFinal2.getMonth();
        const year = dateFinal2.getFullYear();

        return dayNames[weekDay] + ', ' + day + ' ' + monthNames[monthIndex] + ' ' + year;
    }
    getStars() {
        return new Array(this.hotelInfo.stars).fill(0);
    }

    getExtraCost(room) {
        let total = 0;
        const roomRate = room.rateType;
        room.selectedExtrasToShow.forEach(extra => total += (extra.quantity * extra.price));
        if (!(roomRate === 'Standard' || roomRate === 'Non Refundable')) { total *= 1; }
        return total;
    }

    getMealCost(room) {
        let total = 0;
        room.selectedMeals.forEach(extra => total += (extra.quantity * extra.price));
        return total;
    }

    getTotalCost() {
        let totalCost = 0;
        this.rooms.forEach(room => {
            totalCost += (this.getMealCost(room) + this.getExtraCost(room));
            totalCost += (room.room.offerPrice * room.room.selectedRooms *
                this.getNightsSafari(this.bookingRequest.fromdate, this.bookingRequest.todate));
        });
        return totalCost;
    }

    bookNow() {
        this.bookNowEv.emit([this.guestDetails]);
    }
    getAdult(): any {
        return this.bookingRequest.persons[0];
    }
    getChildrens(): any {
        return this.bookingRequest.persons[1];
    }
    showDetails() {

        this.showdetails = !this.showdetails;
        const x = document.getElementById('policies-text');
        if (x.style.display === 'block') {
            x.style.display = 'none';
        } else {
            x.style.display = 'block';
        }
    }

    isDetailsVisible() {
        return this.showdetails;
    }

    isMobile() {
        const w = window.innerWidth;
        if (w < 992) {
            return true;
        }

        return false;
    }
}
